import React, { Component } from "react";

import "./smart-error-console.css";

class SmartErrorConsole extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: ""
        };
    }

    update(e) {
        let { on_change, config } = this.props;
        let newValue = e.target.value;

        let inputName = config.name;
        this.setState({ value: newValue });
        on_change(inputName, newValue);
    }

    printErrors() {
        let { errors } = this.props;

        let i = 0;
        return errors.map((error) => {
            let errorKey = "error" + (i++);
            return <div className='smart_form_error' key={errorKey}>{error}</div>
        });
    }

    render() {
        return (
            <div className='smart_form_error_console'>
                {this.printErrors()}
            </div>
        )
    }
}

export default SmartErrorConsole;


// WEBPACK FOOTER //
// ./src/components/components/smart-form/smart-error-console.js